import * as history from "history";

export const OGS_API_URL = process.env.OGS_API_URL;
export const BONUS_OUTCOME_NAME = "Keno Bonus";
export const BONUS_OUTCOME_TYPE_NAME = "Keno Bonus";
export const DOLLAR_CENT_PLACES = 2;
export const NUMBERS_MAX_ADVANCE_DRAWSDRAWN = 20;
export const MIN_ADVANCE_BUY = 1;
export const BONUS_COST_MULTIPLIER = 2;
export const MIN_NUMBER = 1;
export const MAX_NUMBER = 80;
export const PURCHASE_CONFIRM_SKIP = true;
export const OLD_DRAWS_LIMIT = 10;

export const NUMBERS_TO_DRAW = 20;

export const MOMENT_DATE_FORMAT = "ddd MMM D YYYY";

export const PRODUCTPLAYTYPE_NAME = "Keno";

/**
 * Animations during draw phase
 */
export const BONUS_PHASE_SECONDS = 10; // Whole phase
export const DRAW_NUMBER_SECONDS = 5; // Per Number, will be multiplied by NUMBERS_TO_DRAW
export const HIGHLIGHT_NUMBER_DELAY_SECONDS = 2;

/**
 * ROUTER HISTORY
 * Which form of history to use for the router, out of the box supports:
 * - "createBrowserHistory" to use slashes in the URL
 * - "createHashHistory" to use the hash symbol separator
 *
 * See: https://www.npmjs.com/package/history for more examples.
 */
export const historyCreationFunction = history.createHashHistory;



// WEBPACK FOOTER //
// ./src/settings.ts